import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/restricted-services/login.service';
import { LocalStorageStg } from '../setting/localStorageStg';
import { VarRouterPage } from '../setting/varRouterPage';

@Injectable({
  providedIn: 'root'
})
export class ValidateSignupGuard implements CanActivate {
  constructor(
    private _authentication:LoginService,
    private _router:Router
    ){

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(localStorage.getItem(LocalStorageStg.FLAG_VERIFY) ){
        return true;
      }else{
        return false;
      }
  }
  
}
